module.exports = __webpack_public_path__ + "assets/images/send.5ffde52f.svg";


//////////////////
// WEBPACK FOOTER
// ./imgs/send.svg
// module id = 174
// module chunks = 0